/**
 * Launch flag for the October 2026 pricing (the "v2" plans).
 *
 * When live, the v2 plans (`brandV2`, `agencyCoreV2`, `agencyPro`) and the
 * Perplexity add-on are what we sell; the v1 plans (`brand`,
 * `agencyCoreUsageBased`) are hidden from every picker but stay in config so
 * existing subscribers keep resolving by price id and keep their allowances.
 *
 * Precedent: `NEXT_PUBLIC_WORKFLOWS_ENABLED` in
 * `apps/web/modules/saas/workflows/lib/flags.ts`. The variable is read as a full
 * member expression rather than destructured, because Next.js inlines
 * `process.env.NEXT_PUBLIC_*` at build time only when it can see the whole
 * expression; a destructured read is `undefined` in the browser. Server code
 * reads the same variable at runtime.
 *
 * Launch is one env change plus a redeploy; rollback is unsetting it. v2 plan
 * keys stay in config either way, so v2 subscribers keep resolving after a
 * rollback.
 *
 * Browser-safe: no imports.
 */
export function isPricingV2Live(): boolean {
	return process.env.NEXT_PUBLIC_PRICING_V2 === "1";
}
